import './style.scss';

export const headerBackgroundImage = [
  {
    class: 'sun',
    speed: -0.5,
  },

  {
    class: 'mountain-1',
    speed: -0.6,
  },

  {
    class: 'mountain-2',
    speed: -0.4,
  },

  {
    class: 'mountain-3',
    speed: -0.2,
  },

  {
    class: 'mountain-4',
    speed: -0.1,
  },

  {
    class: 'forest-2',
    speed: -0.05,
  },

  {
    class: 'forest-1',
    speed: 0,
  },
]